document.addEventListener('DOMContentLoaded', function() {
  setupMobileMenu();
  
  // Observar cambios en el nav para recargar el menú cuando se vuelve fixed
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.classList.contains('fixed-nav-active')) {
        resetMobileMenu();
      }
    });
  });
  
  const siteNav = document.querySelector('.site-nav');
  if (siteNav) {
    observer.observe(siteNav, { attributes: true, attributeFilter: ['class'] });
  }
  
  function setupMobileMenu() {
    // Remover hamburguesa existente si hay
    const existingHamburger = document.querySelector('.hamburger-icon');
    if (existingHamburger) {
      existingHamburger.remove();
    }
    
    // Crear botón hamburguesa
    const hamburger = document.createElement('div');
    hamburger.className = 'hamburger-icon';
    
    // Seleccionar elementos del DOM
    const navContent = document.querySelector('.site-nav-content');
    const nav = document.querySelector('.site-nav-content .nav');
    
    if (!navContent || !nav) return;
    
    // Insertar hamburguesa
    navContent.parentNode.insertBefore(hamburger, navContent);
    
    // Preparar enlaces sociales para móvil
    const socialLinks = document.querySelector('.social-links');
    let mobileLinks = document.querySelector('.mobile-social-links');
    
    // Eliminar contenedor social móvil anterior si existe
    if (mobileLinks) {
      mobileLinks.remove();
    }
    
    if (socialLinks) {
      mobileLinks = document.createElement('div');
      mobileLinks.className = 'mobile-social-links';
      mobileLinks.innerHTML = socialLinks.innerHTML;
      nav.appendChild(mobileLinks);
    }
    
    // Toggle menú al hacer clic
    hamburger.addEventListener('click', function() {
      hamburger.classList.toggle('active');
      nav.classList.toggle('active');
      
      if (mobileLinks) {
        mobileLinks.classList.toggle('active', nav.classList.contains('active'));
      }
    });
    
    // Destacar enlace activo
    const currentPath = window.location.pathname;
    const menuLinks = document.querySelectorAll('.nav li a');
    
    menuLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (currentPath === href || (currentPath.includes(href) && href !== '/')) {
        link.parentElement.classList.add('active');
      }
    });
  }
  
  function resetMobileMenu() {
    // Esperar un momento para que el DOM se actualice completamente
    setTimeout(setupMobileMenu, 100);
  }
});